import React from 'react';
import PropTypes from 'prop-types';
import { FaTimes, FaAngleDown } from 'react-icons/fa';  // FaAngleUp
import '../../../styles/common/core/IndicatorsContainer.css'

class IndicatorsContainer extends React.Component {
    static propTypes = {
        clear: PropTypes.bool,
        clearRotate: PropTypes.bool,
        isDisabled: PropTypes.bool,
        angle: PropTypes.bool,
        angleRotate: PropTypes.bool,
        onClearMouseDown: PropTypes.func,
        onAngleMouseDown: PropTypes.func,
    }

    static defaultProps = {
        isDisabled: false,
        clear: false,
        clearRotate: false,
        angle: false,
        angleRotate: false,
        onClearMouseDown: null,
        onAngleMouseDown: null,
    }

    constructor(props) {
        super(props);

        this.state = {
            clear: this.props.clear,
            onClearMouseDown: this.props.onClearMouseDown,
            angle: this.props.angle,
            onAngleMouseDown: this.props.onAngleMouseDown,
        };
    }

    render() {
        const { clear, angle } = this.state;
        const { isDisabled } = this.props;

        return (
            <div className="indicators-container">
                {clear &&
                    <IconContainer
                        disabled={isDisabled}
                        icon={<FaTimes />}
                        onMouseDown={this.state.onClearMouseDown}
                    />}
                {clear && angle && <span className="indicators-separator" />}
                {angle &&
                    <IconContainer
                        disabled={isDisabled}
                        icon={<FaAngleDown
                            className="rotate"
                            data-rotate-up={this.props.angleRotate}
                        />}
                        onMouseDown={this.state.onAngleMouseDown}
                    />}
            </div>
        );
    }
}

export const IconContainer = ({
    icon,
    disabled,
    onMouseDown,
}) => {
    return (
        <div
            className={"indicator-container" + (disabled ? " disable" : "")}
            onMouseDown={disabled ? null : onMouseDown}
        >
            {icon}
        </div>
    );
}

export default IndicatorsContainer;